import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import { ClientConfigProvider } from './context/ClientConfigContext';
import theme from './theme';

// Import pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import EnhancedRegisterPage from './pages/EnhancedRegisterPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import ClientsPage from './pages/ClientsPage';

import CompliancePage from './pages/CompliancePage';
import ValidadoAdminPage from './pages/ValidadoAdminPage';
import CompanyAdminPage from './pages/CompanyAdminPage';
import ClientConfigAdminPage from './pages/ClientConfigAdminPage';
import UnifiedClientPortal from './pages/UnifiedClientPortal';
import DynamicClientPortal from './pages/DynamicClientPortal';
import DocsLandingPage from './pages/DocsLandingPage';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <ClientConfigProvider>
          <Router>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/enhanced-register" element={<EnhancedRegisterPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/clients" element={<ClientsPage />} />

              <Route path="/compliance" element={<CompliancePage />} />
              <Route path="/admin/validado" element={<ValidadoAdminPage />} />
              <Route path="/admin/company" element={<CompanyAdminPage />} />
              <Route path="/admin/client-config" element={<ClientConfigAdminPage />} />
              <Route path="/docs" element={<DocsLandingPage />} />
              <Route path="/client-portal" element={<UnifiedClientPortal />} />
              <Route path="/client-portal/:companyId" element={<DynamicClientPortal />} />
            </Routes>
          </Router>
        </ClientConfigProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
